module.exports = __webpack_public_path__ + "img/hongshaopaigu.b1ea4999.jpg";